import StepsSVG from '../../assets/additional-information-svgs';
import {
  ADDITIONAL_INFORMATION_CITY_COUNTRY_TYPE,
  ADDITIONAL_INFORMATION_OPTION_BOX_TYPE,
  ADDITIONAL_INFORMATION_YEAR_OF_BIRTH_TYPE,
} from '../data/constants';
import messages from '../messages';

const stepsData = [
  {
    id: 1,
    type: ADDITIONAL_INFORMATION_OPTION_BOX_TYPE,
    tabTitle: 'additional.information.education.tab.label',
    pageTitle: 'additional.information.education.title',
    icon: <StepsSVG.FirstStepSVG />,
    fieldKey: 'level_of_education',
  },
  {
    id: 2,
    type: ADDITIONAL_INFORMATION_OPTION_BOX_TYPE,
    tabTitle: 'additional.information.degree.tab.label',
    pageTitle: 'additional.information.degree.title',
    icon: <StepsSVG.SecondStepSVG />,
    fieldKey: 'academic_degree',
  },
  {
    id: 3,
    type: ADDITIONAL_INFORMATION_OPTION_BOX_TYPE,
    tabTitle: 'additional.information.gender.tab.label',
    pageTitle: 'additional.information.gender.title',
    icon: <StepsSVG.ThirdStepSVG />,
    fieldKey: 'gender',
  },
  {
    id: 4,
    type: ADDITIONAL_INFORMATION_YEAR_OF_BIRTH_TYPE,
    tabTitle: 'additional.information.year.of.birth.tab.label',
    pageTitle: 'additional.information.year.of.birth.title',
    icon: <StepsSVG.FourthStepSVG />,
    fieldKey: 'year_of_birth',
  },
  {
    id: 5,
    type: ADDITIONAL_INFORMATION_CITY_COUNTRY_TYPE,
    tabTitle: 'additional.information.residence.tab.label',
    pageTitle: 'additional.information.residence.title',
    icon: <StepsSVG.FifthStepSVG />,
    fieldKey: ['city', 'country'],
  },
];

const useStepsData = (optionalFields, formatMessage) => {
  const { fields } = optionalFields;

  return stepsData.map((step) => {
    const newStep = { ...step };
    const formattedTabTitle = formatMessage(messages[step.tabTitle]);
    const formattedPageTitle = formatMessage(messages[step.pageTitle]);
    newStep.tabTitle = formattedTabTitle;
    newStep.pageTitle = formattedPageTitle;
    newStep.options = step.fieldKey instanceof Array
      ? { ...step.fieldKey.map((key) => ({ [key]: fields[key]?.options || [] })) }
      : fields[step.fieldKey]?.options || [];
    // academic_degree helper step – holds same data as level_of_education
    if (step.fieldKey === 'academic_degree') {
      const levelEducationOptions = fields?.level_of_education?.options || [];
      newStep.options = [...levelEducationOptions];
    }
    return newStep;
  });
};

export default useStepsData;
